import "./sections/download/download";
import "./sections/strategy/strategy";
import "./sections/reviews/reviews";
import "./sections/faq/faq";
import "./sections/table-winners-month/table-winners-month";
import "./hamburger/hamburger";
import "./header/header";
